export const getProtocolEditorAutosave = (state) => state.protocolEditorState.autosave;

export const getProtocolEditorIsPendingSaveExist = (state) => state.protocolEditorState.isPendingSaveExist;

export const getSimpleTransferEditedType = (state) => state.protocolEditorState.simpleTransferEditedType;

export const getSerialDilutionStep = (state) => state.protocolEditorState.serialDilutionStep;

export const getSerialDilutionEditStep = (state) => state.protocolEditorState.serialDilutionEditStep;

export const getProtocolEditorMode = (state) => state.protocolEditorState.selectedMenu;

export const getNormalizationTaskEditStep = (state) => state.protocolEditorState.normalizationTaskEditStep;

export const getCopiedPipettingParameter = (state) => state.protocolEditorState.copiedPipettingParameter;

export const getSelectedTipChannel = (state) => state.protocolEditorState.selectedTipChannel;
